import { lazy } from 'react';

const CustomActiuTelegestio = lazy(() => import('./CustomActiuTelegestio'));

export default CustomActiuTelegestio;
